import React from "react";
import AdPanelList from "../components/AdPanelList";
import PanelLayout from "../components/PanelLayout";
import PanelAdsHeader, { renderPanelTabLabel } from "../components/PanelAdsHeader";
import ModalAdTypePicker from "../components/ModalAdTypePicker";
import AdListSkeleton from "../components/AdListSkeleton";
import { connect } from "react-redux";
import * as actions_sales_active from "../redux/actions/adSalesActions";
import * as actions_sales_inactive from "../redux/actions/adSalesInactiveActions";
import * as actions_rents_active from "../redux/actions/adRentsActions";
import * as actions_rents_inactive from "../redux/actions/adRentsInactiveActions";
import * as actions_auction_active from "../redux/actions/adAuctionActions";
import * as actions_auction_inactive from "../redux/actions/adAuctionInactiveActions";
import * as actions_exchange from "../redux/actions/adExchangeActions";
import * as actions_donation from "../redux/actions/adDonationActions";
import Tabs from "../components/Tabs";
import "./styles/PanelAds.css";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import { hasMoreAds, mergeAdLists } from "../utils/panelAdsUtils";

class PanelAds extends React.Component {
  state = {
    typePickerOpen: false,
  };

  componentDidMount() {
    this.fetchAllAds();
  }

  fetchAllAds = async () => {
    const { user_id, token } = this.props;
    if (!user_id || !token) return;

    const loaders = [
      this.props.LoadSales(user_id, token),
      this.props.LoadSalesInactive(user_id, token),
      this.props.LoadRents(user_id, token),
      this.props.LoadRentsInactive(user_id, token),
      this.props.LoadAuction(user_id, token),
      this.props.LoadAuctionInactive(user_id, token),
      this.props.LoadExchange(user_id, token),
      this.props.LoadDonation(user_id, token),
    ];

    try {
      await Promise.all(loaders);
      this.showFetchErrors();
    } catch (error) {
      console.log(error);
    }
  };

  showFetchErrors = () => {
    const errors = [
      this.props.errorSales,
      this.props.errorSalesInactive,
      this.props.errorRents,
      this.props.errorRentsInactive,
      this.props.errorAuction,
      this.props.errorAuctionInactive,
      this.props.errorExchange,
      this.props.errorDonation,
    ].filter(Boolean);

    if (errors.length) {
      alertify.warning(I18n.t(errors[0]));
    }
  };

  openTypePicker = () => {
    this.setState({ typePickerOpen: true });
  };

  closeTypePicker = () => {
    this.setState({ typePickerOpen: false });
  };

  onClickLoadMoreActive = async () => {
    const { user_id, token } = this.props;
    const tasks = [];

    if (this.props.pageSizeSales > 5) {
      tasks.push(this.props.LoadSalesMore(this.props.pageCountSales, user_id, token));
    }
    if (this.props.pageSizeRents > 5) {
      tasks.push(this.props.LoadRentsMore(this.props.pageCountRents, user_id, token));
    }
    if (this.props.pageSizeAuction > 5) {
      tasks.push(this.props.LoadAuctionMore(this.props.pageCountAuction, user_id, token));
    }
    if (this.props.pageSizeExchange > 5) {
      tasks.push(this.props.LoadExchangeMore(this.props.pageCountExchange, user_id, token));
    }
    if (this.props.pageSizeDonation > 5) {
      tasks.push(this.props.LoadDonationMore(this.props.pageCountDonation, user_id, token));
    }

    try {
      await Promise.all(tasks);
      this.showFetchErrors();
    } catch (error) {
      console.log(error);
    }
  };

  onClickLoadMoreInactive = async () => {
    const { user_id, token } = this.props;
    const tasks = [];

    if (this.props.pageSizeSalesInactive > 5) {
      tasks.push(
        this.props.LoadSalesInactiveMore(
          this.props.pageCountSalesInactive,
          user_id,
          token
        )
      );
    }
    if (this.props.pageSizeRentsInactive > 5) {
      tasks.push(
        this.props.LoadRentsInactiveMore(
          this.props.pageCountRentsInactive,
          user_id,
          token
        )
      );
    }
    if (this.props.pageSizeAuctionInactive > 5) {
      tasks.push(
        this.props.LoadAuctionInactiveMore(
          this.props.pageCountAuctionInactive,
          user_id,
          token
        )
      );
    }

    try {
      await Promise.all(tasks);
      this.showFetchErrors();
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const activeList = mergeAdLists(
      this.props.salesActive,
      this.props.rentsActive,
      this.props.auctionActive,
      this.props.exchangeActive,
      this.props.donationActive
    );

    const inactiveList = mergeAdLists(
      this.props.salesInactive,
      this.props.rentsInactive,
      this.props.auctionInactive
    );

    const loading =
      this.props.loadingSales ||
      this.props.loadingRents ||
      this.props.loadingAuction ||
      this.props.loadingExchange ||
      this.props.loadingDonation;

    const loadingInactive =
      this.props.loadingSalesInactive ||
      this.props.loadingRentsInactive ||
      this.props.loadingAuctionInactive;

    const activeHasMore = hasMoreAds([
      this.props.pageSizeSales,
      this.props.pageSizeRents,
      this.props.pageSizeAuction,
      this.props.pageSizeExchange,
      this.props.pageSizeDonation,
    ]);

    const inactiveHasMore = hasMoreAds([
      this.props.pageSizeSalesInactive,
      this.props.pageSizeRentsInactive,
      this.props.pageSizeAuctionInactive,
    ]);

    const loadingMoreActive =
      this.props.loadingMoreSales ||
      this.props.loadingMoreRents ||
      this.props.loadingMoreAuction ||
      this.props.loadingMoreExchange ||
      this.props.loadingMoreDonation;

    const loadingMoreInactive =
      this.props.loadingMoreSalesInactive ||
      this.props.loadingMoreRentsInactive ||
      this.props.loadingMoreAuctionInactive;

    return (
      <PanelLayout>
        <div className="panel-ads-page">
          <PanelAdsHeader
            title={<Translate value="ads" />}
            onNewClick={this.openTypePicker}
          />

          <div className="panel-ads-page__tabs">
            <Tabs>
              <div
                tabKey="active"
                label={renderPanelTabLabel(I18n.t("ad_active"), activeList.length)}
                className="col-12"
              >
                {loading ? (
                  <AdListSkeleton count={6} />
                ) : (
                  <AdPanelList
                    adPanelList={activeList}
                    loadingMore={loadingMoreActive}
                    pageCount={0}
                    pageSize={activeHasMore ? 6 : 0}
                    onClickLoadMore={this.onClickLoadMoreActive}
                    showKindBadge
                  />
                )}
              </div>
              <div
                tabKey="inactive"
                label={renderPanelTabLabel(
                  I18n.t("ad_inactive"),
                  inactiveList.length
                )}
                className="col-12"
              >
                {loadingInactive ? (
                  <AdListSkeleton count={6} />
                ) : (
                  <AdPanelList
                    adPanelList={inactiveList}
                    loadingMore={loadingMoreInactive}
                    pageCount={0}
                    pageSize={inactiveHasMore ? 6 : 0}
                    isInactiveTab
                    onClickLoadMore={this.onClickLoadMoreInactive}
                    showKindBadge
                  />
                )}
              </div>
            </Tabs>
          </div>
        </div>

        <ModalAdTypePicker
          isOpen={this.state.typePickerOpen}
          onClose={this.closeTypePicker}
        />
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    salesActive: reducer.adSales.list || [],
    salesInactive: reducer.adSalesInactive.list || [],
    rentsActive: reducer.adRents.list || [],
    rentsInactive: reducer.adRentsInactive.list || [],
    auctionActive: reducer.adAuction.list || [],
    auctionInactive: reducer.adAuctionInactive.list || [],
    exchangeActive: reducer.adExchange.list || [],
    donationActive: reducer.adDonation.list || [],
    loadingSales: reducer.adSales.loading,
    loadingSalesInactive: reducer.adSalesInactive.loading,
    loadingRents: reducer.adRents.loading,
    loadingRentsInactive: reducer.adRentsInactive.loading,
    loadingAuction: reducer.adAuction.loading,
    loadingAuctionInactive: reducer.adAuctionInactive.loading,
    loadingExchange: reducer.adExchange.loading,
    loadingDonation: reducer.adDonation.loading,
    loadingMoreSales: reducer.adSales.loadingMore,
    loadingMoreSalesInactive: reducer.adSalesInactive.loadingMore,
    loadingMoreRents: reducer.adRents.loadingMore,
    loadingMoreRentsInactive: reducer.adRentsInactive.loadingMore,
    loadingMoreAuction: reducer.adAuction.loadingMore,
    loadingMoreAuctionInactive: reducer.adAuctionInactive.loadingMore,
    loadingMoreExchange: reducer.adExchange.loadingMore,
    loadingMoreDonation: reducer.adDonation.loadingMore,
    pageCountSales: reducer.adSales.page_count,
    pageSizeSales: reducer.adSales.page_size,
    pageCountSalesInactive: reducer.adSalesInactive.page_count,
    pageSizeSalesInactive: reducer.adSalesInactive.page_size,
    pageCountRents: reducer.adRents.page_count,
    pageSizeRents: reducer.adRents.page_size,
    pageCountRentsInactive: reducer.adRentsInactive.page_count,
    pageSizeRentsInactive: reducer.adRentsInactive.page_size,
    pageCountAuction: reducer.adAuction.page_count,
    pageSizeAuction: reducer.adAuction.page_size,
    pageCountAuctionInactive: reducer.adAuctionInactive.page_count,
    pageSizeAuctionInactive: reducer.adAuctionInactive.page_size,
    pageCountExchange: reducer.adExchange.page_count,
    pageSizeExchange: reducer.adExchange.page_size,
    pageCountDonation: reducer.adDonation.page_count,
    pageSizeDonation: reducer.adDonation.page_size,
    errorSales: reducer.adSales.error,
    errorSalesInactive: reducer.adSalesInactive.error,
    errorRents: reducer.adRents.error,
    errorRentsInactive: reducer.adRentsInactive.error,
    errorAuction: reducer.adAuction.error,
    errorAuctionInactive: reducer.adAuctionInactive.error,
    errorExchange: reducer.adExchange.error,
    errorDonation: reducer.adDonation.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadSales: (user_id, token) =>
    dispatch(actions_sales_active.loadList({ user_id, token })),
  LoadSalesMore: (page_count, user_id, token) =>
    dispatch(actions_sales_active.loadListScroll({ page_count, user_id, token })),
  LoadSalesInactive: (user_id, token) =>
    dispatch(actions_sales_inactive.loadList({ user_id, token })),
  LoadSalesInactiveMore: (page_count, user_id, token) =>
    dispatch(actions_sales_inactive.loadListScroll({ page_count, user_id, token })),
  LoadRents: (user_id, token) =>
    dispatch(actions_rents_active.loadList({ user_id, token })),
  LoadRentsMore: (page_count, user_id, token) =>
    dispatch(actions_rents_active.loadListScroll({ page_count, user_id, token })),
  LoadRentsInactive: (user_id, token) =>
    dispatch(actions_rents_inactive.loadList({ user_id, token })),
  LoadRentsInactiveMore: (page_count, user_id, token) =>
    dispatch(actions_rents_inactive.loadListScroll({ page_count, user_id, token })),
  LoadAuction: (user_id, token) =>
    dispatch(actions_auction_active.loadList({ user_id, token })),
  LoadAuctionMore: (page_count, user_id, token) =>
    dispatch(actions_auction_active.loadListScroll({ page_count, user_id, token })),
  LoadAuctionInactive: (user_id, token) =>
    dispatch(actions_auction_inactive.loadList({ user_id, token })),
  LoadAuctionInactiveMore: (page_count, user_id, token) =>
    dispatch(actions_auction_inactive.loadListScroll({ page_count, user_id, token })),
  LoadExchange: (user_id, token) =>
    dispatch(actions_exchange.loadList({ user_id, token })),
  LoadExchangeMore: (page_count, user_id, token) =>
    dispatch(actions_exchange.loadListScroll({ page_count, user_id, token })),
  LoadDonation: (user_id, token) =>
    dispatch(actions_donation.loadList({ user_id, token })),
  LoadDonationMore: (page_count, user_id, token) =>
    dispatch(actions_donation.loadListScroll({ page_count, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelAds);
